<script setup>
import { DragDropProvider } from '@dnd-kit/vue'
import { Feedback } from '@dnd-kit/dom'
import { isSortable } from '@dnd-kit/vue/sortable'
import RookieSortableDay from './RookieSortableDay.vue'

defineProps({
  days: {
    type: Array,
    required: true,
  },
  cdnUrl: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['reorder', 'remove'])

const plugins = (defaults) => [
  ...defaults,
  Feedback.configure({ feedback: 'clone' }),
]

function onDragEnd(event) {
  if (event.canceled) {
    return
  }

  const { source } = event.operation
  if (!source || !isSortable(source)) {
    return
  }

  const from = source.initialIndex
  const to = source.index
  if (from === to) {
    return
  }

  const group = String(source.group ?? '')
  const day = Number(group.replace(/^day-/, ''))
  if (Number.isNaN(day)) {
    return
  }

  emit('reorder', { day, from, to })
}
</script>

<template>
  <DragDropProvider :plugins="plugins" @drag-end="onDragEnd">
    <RookieSortableDay
      v-for="day in days"
      :key="day.day"
      :day="day"
      :cdn-url="cdnUrl"
      :loading="loading"
      @remove="$emit('remove', $event)"
    />
  </DragDropProvider>
</template>
